<template>
  <div class="need-help-container">
    <div class="need-help-grid">
      <a href="/faq" target="_blank" alt="FAQ" class="need-help-cell">
        <span class="af af-faq need-help-icon"></span>
        <span class="need-help-icon-caption">FAQ</span>
      </a>
      <a href="tel:1-888-746-3455" alt="Call 1.888.746.3455" class="need-help-cell">
        <span class="af af-call need-help-icon"></span>
        <span class="need-help-icon-caption need-help-caption-call-number">+1.888.746.3455</span>
        <span class="need-help-icon-caption need-help-caption-call-callword">CALL</span>
      </a>
      <a alt="Start Chat" class="need-help-cell livechat-link" @click="chat">
        <span class="af af-chat need-help-icon"></span>
        <span class="need-help-icon-caption">CHAT</span>
      </a>
      <a href="mailto:service@article.com" alt="E-Mail service@article.com" class="need-help-cell">
        <span class="af af-mail need-help-icon"></span>
        <span class="need-help-icon-caption">EMAIL</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NeedHelp',

  methods: {
    ...mapActions('common', [
      'chat', //
    ]),
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.need-help-container {
  background-color: var(--background-color);
  font-size: 1.2em;

  .need-help-grid {
    max-width: 600px;
    height: 60px;
    margin: auto;
    padding: 32px 24px;
    display: flex;
    justify-content: space-between;

    .need-help-cell {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span {
        padding: 2px 0;

        &.af {
          font-size: 1.5em;
        }
      }

      .need-help-caption-call-callword {
        display: none;
      }

      @media (max-width: $mobile-breakpoint - 1) {
        .need-help-caption-call-number {
          display: none;
        }
        .need-help-caption-call-callword {
          display: block;
        }
      }
    }
  }
}
</style>
